export enum StoreDiscountTypeEnum {
  FIXED_AMOUNT = "fixed_amount",
  PERCENTAGE = "percentage",
}

export default StoreDiscountTypeEnum;
